import { KyInstance } from 'ky';

export class AuthService {
    constructor(private readonly authClient: KyInstance) {}

    logout = (): Promise<string> => {
        return this.authClient.get('google/logout').json();
    }
}
